/**
 * Knowledge Graph types — per-project persistent agent memory.
 *
 * Entities are nodes in the graph (user preferences, coding style, etc.).
 * Observations are facts attached to entities.
 * Relations are edges between entities.
 */
// ─── Entity Types ────────────────────────────────────────────────────────────
export const KNOWLEDGE_ENTITY_TYPES = [
    'preference',
    'style',
    'context',
    'expertise',
    'workflow',
    'personality',
    'custom',
];
// ─── Observation Types ───────────────────────────────────────────────────────
export const KNOWLEDGE_SOURCE_TYPES = ['explicit', 'inferred', 'behavioral'];
// ─── Relation Types ──────────────────────────────────────────────────────────
export const KNOWLEDGE_RELATION_TYPES = [
    'influences',
    'contradicts',
    'supports',
    'requires',
    'related_to',
];
// ─── Defaults ────────────────────────────────────────────────────────────────
export const KNOWLEDGE_DEFAULTS = {
    maxEntitiesPerProject: 500,
    maxObservationsPerEntity: 100,
    searchLimit: 20,
    searchMaxLimit: 100,
    listPageSize: 50,
    listMaxPageSize: 200,
    autoRetrieveLimit: 20,
    autoRetrieveMinConfidence: 0.8,
    autoRetrieveHighConfidenceLimit: 50,
    observationMaxLength: 1000,
    entityNameMaxLength: 200,
    descriptionMaxLength: 2000,
    defaultConfidence: 0.7,
};
//# sourceMappingURL=knowledge.js.map